import Request from './request';

export default class BranchHttpService {
    private static uri = 'branches';

    public static readMany(params: {
        skip?: number;
        take?: number;
        term?: string;
        cnpj?: string;
    }) {
        return Request.get(`${this.uri}`, params);
    }
}
